import { Table, PageHeader } from "antd";
import moment from "moment";
import { useForm } from "react-hook-form";

import React, { useEffect, useState } from "react";
import { createComponentStore, useStoreState } from "easy-peasy";
import { RULES } from "Constants/rules";
import {
  RealEstateAp7ReportStoreModel,
  ACTION_TYPES,
} from "store/models/reports/real-estate-ap7";
import ExportExcel from "Components/export-excel";
import DeedTypeSelect from "Components/deed-type-select";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import FourOThree from "Pages/private/403";

const useRealEstateAp7ReportsStore = createComponentStore(
  RealEstateAp7ReportStoreModel
);

export default function RealEstate7ReportPage() {
  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.READ,
    "Taşınmaz Raporları"
  );

  const [store, actions] = useRealEstateAp7ReportsStore();
  const { fetch } = actions;
  const { process, data } = store;
  const [filteredValue, setFilteredValue] = useState({});

  const form = useForm({
    defaultValues: {
      deedType: null,
    },
  });

  const deedType = form.watch("deedType");

  useEffect(() => {
    fetch(filteredValue);
  }, [filteredValue]);

  useEffect(() => {
    if (deedType) setFilteredValue({ deedtypescode: deedType.code });
    else setFilteredValue({});
  }, [deedType]);

  const columns = [
    {
      title: "Tapu Kodu",
      dataIndex: "deedTypeCode",
      sorter: (a, b) =>
        a.deedTypeCode.split(".")[0] - b.deedTypeCode.split(".")[0],
      width: 80,
      key: "deedTypeCode",
    },

    {
      title: "Taşınmaz Cinsi",
      dataIndex: "deedTypeDesc",
      key: "deedTypeCode",
      width: 110,
      ellipsis: true,
    },

    {
      title: "Geçen Yıldan Devreden",
      width: 300,
      ellipsis: true,
      children: [
        {
          title: "Adedi",
          dataIndex: "lastYearRealEstatePiece",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Yüzölçümü",
          dataIndex: "lastYearFloorSpace",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Değeri",
          dataIndex: "lastYearRealEstateValue",
          width: 100,
          ellipsis: true,
        },
      ],
    },
    {
      title: "Yıl İçinde Edinilen",
      width: 300,
      ellipsis: true,
      children: [
        {
          title: "Adedi",
          dataIndex: "currentYearRealEstatePieceIn",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Yüzölçümü",
          dataIndex: "currentYearFloorSpaceIn",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Değeri",
          dataIndex: "currentYearRealEstateValueIn",
          width: 100,
          ellipsis: true,
        },
      ],
    },
    {
      title: "Yıl İçinde Elden Çıkan",
      width: 300,
      ellipsis: true,
      children: [
        {
          title: "Adedi",
          dataIndex: "currentYearRealEstatePieceOut",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Yüzölçümü",
          dataIndex: "currentYearFloorSpaceOut",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Değeri",
          dataIndex: "currentYearRealEstateValueOut",
          width: 100,
          ellipsis: true,
        },
      ],
    },
    {
      title: "Gelecek Yıla Devreden",
      width: 300,
      ellipsis: true,
      children: [
        {
          title: "Adedi",
          dataIndex: "nextYearRealEstatePiece",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Yüzölçümü",
          dataIndex: "nextYearFloorSpace",
          width: 100,
          ellipsis: true,
        },
        {
          title: "Değeri",
          dataIndex: "nextYearRealEstateValue",
          width: 100,
          ellipsis: true,
        },
      ],
    },
  ];

  const getExcelColumns = () => {
    //return columns.map((d) => d.title);
    return [
      "Tapu Kodu",
      "Taşınmaz Cinsi",
      "Adedi-(Geçen Yıldan Dev.)",
      "Yüzölçümü-(Geçen Yıldan Dev.)",
      "Değeri-(Geçen Yıldan Dev.)",
      "Adedi-(Yıl İçinde Edn.)",
      "Yüzölçümü-(Yıl İçinde Edn.)",
      "Değeri-(Yıl İçinde Edn.)",
      "Adedi-(Yıl İçinde Elden Çkn.)",
      "Yüzölçümü-(Yıl İçinde Elden Çkn.)",
      "Değeri-(Yıl İçinde Elden Çkn.)",
      "Adedi-(Gelecek Yıla Dev.)",
      "Yüzölçümü-(Gelecek Yıla Dev.)",
      "Değeri-(Gelecek Yıla Dev.)",
    ];
  };

  const getExcelRows = () => {
    let rows = [];
    store.data.forEach((d) => {
      let i = [];
      i.push(d.deedTypeCode || "-");
      i.push(d.deedTypeDesc || "-");

      i.push(d.lastYearRealEstatePiece);
      i.push(d.lastYearFloorSpace);
      i.push(d.lastYearRealEstateValue);

      i.push(d.currentYearRealEstatePieceIn);
      i.push(d.currentYearFloorSpaceIn);
      i.push(d.currentYearRealEstateValueIn);

      i.push(d.currentYearRealEstatePieceOut);
      i.push(d.currentYearFloorSpaceOut);
      i.push(d.currentYearRealEstateValueOut);

      i.push(d.nextYearRealEstatePiece);
      i.push(d.nextYearFloorSpace);
      i.push(d.nextYearRealEstateValue);

      //Burası düzenlenecek

      rows.push(i);
    });

    return rows;
  };

  const getExcelFileName = () => {
    switch (deedType?.root?.rule?.code) {
      case RULES.RULE0009:
        return (
          "Taşınmaz Ek-7A Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
      case RULES.RULE0010:
        return (
          "Taşınmaz Ek-7B Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
      case RULES.RULE0011:
        return (
          "Taşınmaz Ek-7C Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
      case RULES.RULE0012:
        return (
          "Taşınmaz Ek-7D Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
      case RULES.RULE0013:
        return (
          "Taşınmaz Ek-7E Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
      default:
        return (
          "Taşınmaz Ek-7 Raporları_" + moment(new Date()).format("DD-MM-YYYY")
        );
    }
  };

  const getTitle = () => {
    switch (deedType?.root?.rule?.code) {
      case RULES.RULE0009:
        return "Ek-7/A Tapuda Kayıtlı Olan Taşınmazlar İçin İcmal Cetveli";
      case RULES.RULE0010:
        return "Ek-7/B Tapuda Kayıtlı Olmayan Taşınmazlar İçin İcmal Cetveli";
      case RULES.RULE0011:
        return "Ek-7/C Orta Malları İçin İcmal Cetveli";
      case RULES.RULE0012:
        return "Ek-7/D Genel Hizmet Alanları İçin İcmal Cetveli";
      case RULES.RULE0013:
        return "Ek-7/E Sınırlı Ayni Haklar İle Kişisel Haklar ve Tahsis İçin İcmal Cetveli";
      default:
        return "Taşınmaz Ek-7 Raporları";
    }
  };

  return IsAuthorized ? (
    <>
      <PageHeader
        title={getTitle()}
        extra={[
          <DeedTypeSelect
            form={form}
            field="deedType"
            placeholder="Taşınmaz Cinsi ile filtrele"
            allowClear={true}
            style={{ width: "220px", paddingLeft: "16px" }}
          />,
          <ExportExcel
            columnsData={getExcelColumns()}
            key={data}
            disabled={data.length < 1}
            rowsData={getExcelRows()}
            loading={store.process === ACTION_TYPES.FETCHING_DATA}
            filename={getExcelFileName()}
            colWidth={30}
          />,
        ]}
      />
      <Table
        style={{ margin: "0 24px" }}
        rowKey={(row) => row.id}
        loading={process === ACTION_TYPES.FETCHING_DATA}
        dataSource={data}
        columns={columns}
        size="small"
        bordered
        showSorterTooltip={false}
        scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
        pagination={{
          pageSize: 20,
          total: data.length,
          showSizeChanger: false,
          showTotal: (total, range) => {
            return `Toplam ${total} sonuçtan ${range.join(
              "-"
            )} arası gösteriliyor.`;
          },
        }}
      />
    </>
  ) : (
    <FourOThree />
  );
}
